import * as React from "react"
import { Tooltip } from "@material-ui/core";
import './ExportInProgress.scss'
import Excell from "../../assets/icons/excel.svg";
import Rest from "src/services/Rest";
import { useEffect } from "react";

export interface IExportInProgressPros {
    msg?: string;
    visible: boolean; 
    handleState: (value: boolean) => void;
    tipos: string [];
}

const ExportInProgress:React.FC<IExportInProgressPros> = (props) => { 
   
    const {msg, visible, handleState, tipos} = props
    const itemVisible = () => {     
      return (  <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
            <Tooltip title={ msg ? msg : 'O relatório está sendo processado. Você receberá um alerta em breve'}>
              <img src={ Excell  } height={'30px'} />
            </ Tooltip> 
            <span style={{fontSize: '10px'}}>Processando....</span> 
      </div> )
    }


  const existProcessamento = () => { 
     
      let endPoint = 'exportacao/andamento'

      tipos.forEach((v, index) => {
          if(index===0) {
            endPoint += `?tipo=${v}`;
          }else {
            endPoint += `&tipo=${v}`;
          }
      })
      
      Rest.GET(endPoint, null)
      .then((result):any => result.json())
      .then(response => {  
        
        if (response && response.length > 0 && visible) {
          setTimeout(() => existProcessamento(), 30000) 
        }
        
        if(response && response.length > 0 && !visible) {
          handleState(true)  
          setTimeout(() => existProcessamento(), 30000)         
        }
        
        if (response && response.length < 1 && visible) {
          handleState(false) 
        } 

      })
      .catch(err => {
          console.log(err)
      })     
    }

  useEffect(() => {
    if(visible) {
      setTimeout(() => existProcessamento(), 30000)
    }
  }, [visible]) 

  useEffect(() =>  {
    existProcessamento()
  }, [])

    return (
       <>
          { visible ? itemVisible() : ''}        
       </>
    )
}

export default ExportInProgress


// WEBPACK FOOTER //
// ./src/component/export-in-progress/ExportInProgress.tsx